import commonApi from './CommonApi.js';

export default {
	create: async (viewModel) => {
		return await commonApi().post('/v1/userFilters', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
	delete: async (parameters) => {
		return await commonApi().delete('/v1/userFilters', { params: parameters })
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getForDropdown: async (parameters) => {
		return await commonApi().get('/v1/userFilters/getForDropdown', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	getFilter: async (parameters) => {
		return await commonApi().get('/v1/userFilters/getFilter', { params: parameters })
			.then((response) => {
				return response.data;
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
	edit: async (viewModel) => {
		return await commonApi().put('/v1/userFilters', viewModel)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				return error.response;
			});
	},
}